import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@contexts/AuthContext";
import { useEmpresa } from "@contexts/EmpresaContext";
import { rotaInicialPorPapel } from "@utils/papeis";
import LoadingScreen from "./LoadingScreen";

const ProtectedRoute = ({ children, adminOnly = false, papeis = null }) => {
  const { isAuthenticated, loading, isAdmin } = useAuth();
  const { papelNaEmpresaAtiva, loading: empresaLoading } = useEmpresa();
  const location = useLocation();

  // Show loading screen while checking authentication
  if (loading) {
    return <LoadingScreen />;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Destino de qualquer bloqueio: a tela inicial do PAPEL, não /dashboard (que
  // só o administrador consegue usar; ver rotaInicialPorPapel).
  // Check admin permissions if required
  if (adminOnly && !isAdmin()) {
    if (empresaLoading) {
      return <LoadingScreen />;
    }
    return <Navigate to={rotaInicialPorPapel(papelNaEmpresaAtiva)} replace />;
  }

  if (papeis) {
    if (empresaLoading) {
      return <LoadingScreen />;
    }
    if (!papeis.includes(papelNaEmpresaAtiva)) {
      return <Navigate to={rotaInicialPorPapel(papelNaEmpresaAtiva)} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
